<template>

    <v-card raised :color="color" :height="height" style="cursor: default;">

        <v-card-text @mouseover="mouseOver=true" @mouseout="mouseOver=false">

            <v-icon v-show="showIndicator && showPrimary" small class="cornerIcon">mdi-information-outline</v-icon>

            <div v-show="showPrimary">
                <div v-if="hintAtTop" class="pb-2 white--text">
                    {{ hint }}
                </div>

                <div v-show="showPrimary" class="display-1 white--text">
                    {{ value }}
                </div>
            </div>

            <div v-show="!showPrimary">
                <div v-show="hintAtTop" class="pb-2 white--text">
                    {{ mouseOverHint }}
                </div>

                <div class="display-1 white--text">
                    {{ mouseOverValue }}
                </div>
            </div>

            <v-progress-circular
                    v-show="loading"
                    indeterminate
                    color="white"
                    :size="contentHeight"
                    :width="5"
            ></v-progress-circular>

            <v-spacer></v-spacer>

            <div v-show="showPrimary && !hintAtTop" class="pt-2 white--text">
                {{ hint }}
            </div>

            <div v-show="!showPrimary && !hintAtTop" class="white--text">
                {{ mouseOverHint }}
            </div>

        </v-card-text>
    </v-card>

</template>

<script>

    import ValueBox from './AnimatedValue';
    import {v4 as uuid} from 'uuid';

    export default {

        components: {
            ValueBox,
        },

        props: {
            'value': {
                type: String,
                required: true,
                default: null
            },
            'prefix': {
                type: String,
                required: false,
                default: ''
            },
            'prefixIcon': {
                type: String,
                required: false,
                default: null,
            },
            'postfix': {
                type: String,
                required: false,
                default: ''
            },
            'postfixIcon': {
                type: String,
                required: false,
                default: ''
            },
            'hint': {
                type: String,
                required: true,
            },
            'mouseOverValue': {
                type: Number | null,
                required: false,
                default: null
            },
            'mouseOverPrefix': {
                type: String,
                required: false,
                default: ''
            },
            'mouseOverPrefixIcon': {
                type: String,
                required: false,
                default: null,
            },
            'mouseOverPostfix': {
                type: String,
                required: false,
                default: ''
            },
            'mouseOverPostfixIcon': {
                type: String,
                required: false,
                default: ''
            },
            'mouseOverHint': {
                type: String,
                required: false
            },

            'height': {
                type: Number,
                required: false,
                default: 100
            },
            'color': {
                type: String,
                required: false,
                default: 'primary'
            },
            'loading': {
                type: Boolean,
                required: false,
                default: false
            },
            'hintAtTop': {
                type: Boolean,
                required: false,
                default: false
            }
        },

        data() {
            return {
                mouseOver: false,
                key: null,
                keyMouseOver: null,
            }
        },

        mounted() {
            this.key = uuid();
            this.keyMouseOver = uuid();
        },

        computed: {
            contentHeight() {
                return this.height - 52;
            },

            showPrimary() {
                return this.mouseOver === false || this.mouseOverValue === null
            },

            showIndicator() {
                return this.mouseOverValue !== null;
            }
        },
    }
</script>

<style scoped>

    .cornerIcon {
        position: absolute;
        top: 10px;
        right: 10px;
    }

</style>
